import { FolkSpaceProjector } from '../folk-space-projector';
FolkSpaceProjector.define();
export { FolkSpaceProjector };
//# sourceMappingURL=folk-space-projector.js.map